import { RawHtml, isSvg } from "../../../lib/ReactUtils";
import React, { useState } from "react";
import InfoButton from "./InfoButton";
import MinimizeIcon from "../../Elements/Icons/MinimizeIcon";
import ReactMarkdown from "react-markdown/with-html";
import Suggestion from "../Chat/Suggestions/Suggestion/Suggestion";
import Tag from "../Tags/Tag";
import { createUseStyles } from "react-jss";
import { makeStylesFromThemeAndCustomStyles } from "../../../lib/StyleFunctions";
import { mergeDeepRight } from "ramda";
import tagStylesObject from "../Tags/BetaTagStyles";

const makeStyles = (theme) =>
  mergeDeepRight(
    {
      headerInterface: {
        zIndex: "5",
        width: "100%",
      },
      innerHeaderInterface: {
        margin: "0",
        padding: "0",
        lineHeight: "1",
        width: "100%",
        boxSizing: "content-box",
        boxShadow: "none",
        height: "42px",
        backgroundColor: theme.chatHeader,
        border: "none",
        display: "flex",
        justifyContent: "space-between",
      },
      title: {
        color: "white",
        fontWeight: "500",
        fontSize: "18px",
        padding: "10px 10px 10px 15px",
        lineHeight: "normal",
        display: "inline-flex",
        margin: "0",
      },
      logo: { margin: "12px" },
      ButtonsContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        width: "auto",
      },
      minimize: {
        backgroundColor: "transparent",
        border: "0px none transparent",
        boxSizing: "border-box",
        color: "white",
        cursor: "pointer",
        cssFloat: "right",
        fontSize: "20px",
        marginLeft: "10px",
        paddingRight: "15px !important",
        height: "100% !important",
      },
      informationButton: {
        composes: "$minimize",
        width: "18px",
        fontSize: "15px",
        paddingTop: "2px !important",
      },
      ribbonContainer: {
        backgroundColor: "white",
        maxHeight: "340px",
        minHeight: "230px",
        transitionProperty: "all",
        transitionDuration: "0.5s",
        transitionTimingFunction: "ease-in-out",
      },
      "@keyframes slide-up": {
        "0%": { opacity: "0", transform: "scaleY(0)" },
        "100%": { opacity: "1", transform: "scaleY(1)" },
      },
      ribbonContainerClose: {
        maxHeight: "0px",
        minHeight: "0px",
        paddingBottom: "0",
      },
      ribbon: {
        color: theme.textColor,
        fontSize: "13px",
        lineHeight: "20px",
        fontWeight: "400",
        padding: "20px 22px 7px 22px",
      },
      ribbonSuggestionContainer: {
        marginLeft: "17px",
        marginBottom: "17px",
      },
    },
    tagStylesObject(theme)
  );

const TopRibbon = ({ text, styles, showRibbon, closeRibbon }) => (
  <div
    className={[
      styles.ribbonContainer,
      !showRibbon ? styles.ribbonContainerClose : null,
    ].join(" ")}
  >
    <ReactMarkdown source={text} className={styles.ribbon} />
    <div className={styles.ribbonSuggestionContainer}>
      <Suggestion displayText={"Got it"} handleClick={closeRibbon} />
    </div>
  </div>
);

const Header = ({
  title,
  isBeta,
  closeWidget,
  headerLogo,
  topRibbonText,
  customWidgetStyle,
}) => {
  const [showRibbon, setShowRibbon] = useState(false);
  const useStyles = createUseStyles(
    makeStylesFromThemeAndCustomStyles(makeStyles, customWidgetStyle)
  );
  const styles = useStyles();
  headerLogo =
    customWidgetStyle && customWidgetStyle.headerLogo
      ? customWidgetStyle.headerLogo
      : headerLogo;

  return (
    <>
      <div className={styles.headerInterface}>
        <div className={styles.innerHeaderInterface}>
          {headerLogo ? (
            isSvg(headerLogo) ? (
              <RawHtml className={styles.logo} tag={"span"}>
                {headerLogo}
              </RawHtml>
            ) : (
              <img className={styles.logo} src={headerLogo} alt="" />
            )
          ) : null}
          <h3 className={styles.title}>
            {title}
            {isBeta ? <Tag styles={styles} tagText={"BETA"} /> : null}
          </h3>
          <div className={styles.ButtonsContainer}>
            {topRibbonText ? (
              <InfoButton
                onClick={() => setShowRibbon(!showRibbon)}
                className={styles.informationButton}
              />
            ) : null}
            <button
              onClick={closeWidget}
              className={styles.minimize}
              aria-label="Minimize chat widget"
              title="Minimize chat widget"
              id={Header.MINIMIZER_ID}
            >
              <MinimizeIcon />
            </button>
          </div>
        </div>
      </div>
      {topRibbonText ? (
        <TopRibbon
          text={topRibbonText}
          styles={styles}
          showRibbon={showRibbon}
          closeRibbon={() => {
            setShowRibbon(false);
          }}
        />
      ) : null}
    </>
  );
};

Header.MINIMIZER_ID = "hyro-minimizer";

export default Header;
